export default {
  common: {
    edited: 'Modificato',
    error: {
      general: 'Ops!',
      failedToOpenMaps: 'Impossibile aprire la mappa',
      failedToOpenLink:
        'Impossibile aprire il link. Nessun browser web è disponibile su questo dispositivo.',
      reportTooMany: "Hai inviato molte segnalazioni di recente. Aspetta un po' e riprova.",
      reportFailed: 'Non siamo riusciti ad aprire il modulo di segnalazione. Riprova.',
      reportUnavailable: 'Questo contenuto non è più disponibile per la segnalazione.',
      popupBlocked:
        "Il tuo browser ha bloccato l'apertura del modulo. Consenti i pop-up per questo sito e riprova.",
      ipBlocked:
        'Il tuo indirizzo IP è stato bloccato a causa di attività sospette. Se ritieni che si tratti di un errore, contatta il supporto.',
      crashTitle: 'Ops! Qualcosa è andato storto',
      crashSubtitle: 'Siamo stati avvisati e stiamo indagando.',
      crashReload: 'Ricarica',
      crashRetry: 'Riprova',
    },
    updateBanner: {
      message: 'Abbiamo apportato alcune migliorie',
      refresh: 'Ricarica',
    },
    connection: {
      offline: 'Nessuna connessione a internet',
      connecting: 'Connessione in corso...',
    },
    success: 'Successo!',
    follow: 'Segui',
    unfollow: 'Non seguire più',
    followed: 'Seguito',
    message: 'Messaggio',
    empty: 'Niente da vedere qui per ora',
    post: 'post',
    comment: 'commento',
    photo: 'foto',
    month: 'mese',
    year: 'anno',
    cancel: 'Annulla',
    continue: 'Continua',
    back: 'Indietro',
    delete: 'Elimina',
    update: 'Aggiorna',
    saveChanges: 'Salva modifiche',
    scrollToTop: 'Vai su',
    undo: 'Annulla',
    report: 'Segnala',
    openingForm: 'Apertura del modulo...',
    accept: 'Accetta',
    reject: 'Rifiuta',
    retry: 'Riprova',
    send: 'Invia',
    unblock: 'Sblocca',
    comingSoon: 'Prossimamente',
    loading: 'Caricamento...',
    done: 'Fatto',
    clear: 'Cancella',
    clearAll: 'Ripristina',
    search: 'Cerca...',
    share: {
      success: 'Condiviso con successo',
      error: 'Errore nella condivisione',
      copied: 'Link copiato negli appunti',
      shareLink: 'Condividi link',
      url: 'URL',
      copy: 'Copia',
      open: 'Apri',
    },
    validation: {
      min: 'Deve contenere almeno {{minLength}} caratteri',
      max: 'Deve contenere al massimo {{maxLength}} caratteri',
      required: 'Questo campo è obbligatorio',
      requiredField: '{{field}} è obbligatorio',
    },
    filters: {
      myType: 'il mio tipo',
      all: 'filtri',
    },
    relativeTime: {
      now: 'ora',
      justNow: 'proprio ora',
    },
  },
  myTypeFilter: {
    title: 'Filtro Il Mio Tipo',
    enableOption: 'Attiva',
    disableOption: 'Disattiva',
    statusEnabled: 'Attivo',
    statusDisabled: 'Inattivo',
    configure: 'Configura…',
    configureTitle: 'Configura Filtro Il Mio Tipo',
    enabled: 'Filtro Il Mio Tipo attivato',
    disabled: 'Filtro Il Mio Tipo disattivato',
    enableError: 'Impossibile attivare il filtro',
    disableError: 'Impossibile disattivare il filtro',
    infoTitle: "Cos'è il Filtro Il Mio Tipo?",
    infoDescription:
      'Imposta le tue preferenze una volta e le liste di post, membri e foto mostreranno automaticamente solo le persone che corrispondono ai tuoi criteri. Puoi attivare o disattivare questo filtro in qualsiasi momento.',
    preview: 'Anteprima',
    apply: 'Applica',
    appliedSuccess: 'Impostazioni del filtro salvate',
    appliedError: 'Impossibile salvare le impostazioni del filtro',
    filteredOutPercent: '{{percent}}% dei membri filtrati',
    filterWarning: 'Filtrare troppe persone potrebbe influire sulla tua esperienza.',
  },
  sensitiveContent: {
    title: 'Contenuti Sensibili',
    statusHidden: 'Nascosto',
    statusVisible: 'Visibile',
    configure: 'Configura...',
  },
  navigation: {
    feeds: 'Feed',
    people: 'Membri',
    photo: 'Foto',
    photos: 'Foto',
    events: 'Eventi',
    discover: 'Scopri',
  },
  communities: {
    myCommunities: 'Le mie community',
    menu: {
      remove: 'Rimuovi da Le mie community',
    },
    delete: {
      confirmTitle: 'Rimuovi community',
      confirmMessage:
        'Sei sicuro di voler rimuovere {{communityName}} da Le mie community? Potrai accedere di nuovo più tardi.',
      success: 'Community rimossa',
      error: 'Impossibile rimuovere la community',
    },
    visitSite: 'Visita {{communityName}}',
  },
  auth: {
    createAccount: 'Crea account',
    signIn: {
      title: 'Accedi',
      welcomeBack: 'Bentornato!',
      heading: 'Accedi a {{communityName}}',
      usernameLabel: 'Nome utente',
      usernamePlaceholder: 'Inserisci il nome utente',
      usernameNotFound: 'Nome utente non trovato',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Inserisci la password',
      passwordIncorrect: 'Password o nome utente errati',
      rememberMe: 'Ricordami',
      forgotPassword: 'Password dimenticata?',
      submit: 'Accedi',
      submitting: 'Accesso in corso...',
      noAccount: 'Non hai un account?',
      signUp: 'Registrati',
      loginFailedToast: 'Accesso non riuscito',
      removeCredentialsError: 'Impossibile rimuovere le credenziali',
      unexpectedError: 'Si è verificato un errore imprevisto',
    },
    signUp: {
      redirectHelper:
        "Verrai reindirizzato al nostro sito legacy di {{communityName}} per creare un account. Una volta creato l'account, potrai tornare a questa app per accedere.",
      successToast: 'Account creato. Ti abbiamo inviato la password via e‑mail.',
    },
    forgotPassword: {
      title: 'Password dimenticata',
      redirectHelper:
        "Verrai reindirizzato al nostro sito legacy di {{communityName}} per reimpostare la password. Dopo aver ricevuto la nuova password via email, torna all'app per accedere.",
      successToast: 'Ti abbiamo inviato una nuova password via e‑mail.',
    },
  },
  feeds: {
    global: 'Feed globale',
    global_short: 'Globale',
    local: 'Feed locale',
    local_short: 'Locale',
    network: 'Feed seguiti',
    network_short: 'Seguiti',
    search: 'Ricerca',
    search_short: 'Cerca',
    search_placeholder: 'Ricerca nei post',
    empty: 'Spiacenti, nessun risultato trovato',
    latestSearches: 'Ricerche recenti',
    popularSearches: 'Ricerche popolari',
    popularHashtags: 'Hashtags popolari',
    onlineMembers: 'Online ora',
    profileVisitors: 'Hanno visitato il mio profilo',
    searchMembersHint: 'Cerchi qualcuno?',
    searchMembersLink: 'Cerca membri',
    pinned: 'Impostato come feed predefinito',
    unpinned: 'Feed globale ripristinato come predefinito',
    alreadyDefault: 'Questo è già il tuo feed predefinito. Passa a un altro feed per cambiarlo.',
    radius: {
      title: 'Raggio',
      km: 'km',
      mi: 'mi',
    },
  },
  messages: {
    title: 'Messaggi',
    inbox: 'Posta',
    inboxBadgeUnreadCaption_one: 'non letto',
    inboxBadgeUnreadCaption_other: 'non letti',
    inboxBadgeMessagesCaption_one: 'messaggio',
    inboxBadgeMessagesCaption_other: 'messaggi',
    unread: 'Non letti',
    online: 'In linea',
    deleted: 'Eliminati',
    emptyDeleted: 'Nessuna conversazione eliminata negli ultimi 90 giorni',
    search: 'Ricerca',
    search_placeholder: 'Inserisci un nome utente',
    empty: 'Nessun messaggio da mostrare',
    conversation: 'Conversazione',
    emptyConversation: 'Nessun elemento di conversazione da mostrare',
    typeMessage: 'Scrivi un messaggio...',
    photoMessage: 'ha inviato una foto',
    gifMessage: 'ha inviato un GIF',
    stickerMessage: 'ha inviato uno sticker',
    clipMessage: 'ha inviato un clip',
    youSentPhoto: 'Hai inviato una foto',
    youSentGif: 'Hai inviato un GIF',
    youSentSticker: 'Hai inviato uno sticker',
    youSentClip: 'Hai inviato un clip',
    replyFailed: 'Invio della risposta non riuscito',
    compose: {
      messageToUser: 'Messaggio a {{userName}}',
      enterMessage: 'Scrivi il tuo messaggio...',
    },
    errors: {
      failedToLoad: 'Impossibile caricare la conversazione',
      failedToSend: 'Impossibile inviare il messaggio',
    },
    success: {
      messageSent: 'Messaggio inviato con successo',
    },
    loadOlderMessages: 'Carica messaggi precedenti',
    loadingOlderMessages: 'Caricamento messaggi precedenti...',
    loadingNewerMessages: 'Caricamento nuovi messaggi...',
    markAsRead: {
      error: 'Impossibile contrassegnare il messaggio come letto',
    },
    markAsUnread: {
      error: 'Impossibile contrassegnare il messaggio come non letto',
    },
    delete: {
      success: 'Messaggio eliminato con successo',
      error: 'Impossibile eliminare il messaggio',
    },
    undelete: {
      success: 'Messaggio ripristinato con successo',
      error: 'Impossibile ripristinare il messaggio',
    },
    menu: {
      markRead: 'Segna come letto',
      markUnread: 'Segna come non letto',
      viewProfile: 'Visualizza profilo',
      deleteConversation: 'Elimina conversazione',
      restoreConversation: 'Ripristina conversazione',
      reportConversation: 'Segnala conversazione',
    },
    copy: {
      success: 'Contenuto copiato negli appunti',
      error: 'Impossibile copiare il contenuto',
      noContent: 'Nessun contenuto da copiare',
    },
    download: {
      label: 'Salva foto',
      success: 'Foto salvata nella tua libreria',
      error: 'Impossibile salvare la foto',
      permissionDenied: 'Serve il permesso per la libreria foto per salvare le foto',
    },
    unreadMessage: 'Messaggio non letto',
    uploadPhoto: 'Carica immagine',
    dropImageToSend: "Rilascia l'immagine per inviare",
    dropImageToSendToUser: "Rilascia l'immagine per inviare a {{userName}}",
    sendPhoto: 'Invia foto',
    photoUploadFailed: 'Caricamento immagine fallito',
    photoUploadSuccess: 'Immagine caricata con successo',
    selectPhoto: 'Foto',
    takePhoto: 'Fotocamera',
    cancel: 'Annulla',
    confirm: 'Conferma',
    cameraPermissionNotGranted: 'Permesso fotocamera non concesso',
    mediaLibraryPermissionNotGranted: 'Permesso libreria multimediale non concesso',
    failedToPickImage: "Impossibile selezionare l'immagine",
    imageTooLarge: "L'immagine è troppo grande. La dimensione massima è {{size}}MB.",
    adminClosedInfo:
      'Questa conversazione è chiusa. Per eventuali follow‑up, apri un ticket di supporto e includi i dettagli rilevanti.',
    contactSupport: 'Contatta il supporto',
    newAccountNotice: {
      title: '{{name}} ha un account recente',
      body: 'Prenditi il tuo tempo per conoscere i nuovi membri. Fai attenzione a condividere informazioni personali e diffida se ti chiedono di spostare la chat su Telegram, WhatsApp, SMS o qualsiasi altro servizio di messaggistica.',
    },
  },
  people: {
    nearby: 'Membri vicini',
    nearby_short: 'Vicino',
    online: 'Membri online',
    online_short: 'Online',
    birthdays: 'Compleanni',
    birthdays_short: 'Compleanni',
    new: 'Nuovi membri',
    new_short: 'Nuovi',
    following: 'Membri che seguo',
    following_short: 'Seguiti',
    followers: 'I miei follower',
    followers_short: 'Follower',
    visitors: 'I miei visitatori',
    visitors_short: 'Visitatori',
    search: 'Ricerca membri',
    search_short: 'Ricerca',
    empty: 'Spiacente, questo è vuoto',
    displayModeCompact: 'Vista compatta',
    displayModeRegular: 'Vista normale',
    nearbyFilter: {
      online: 'Online',
      recent: 'Recenti',
      active: 'Ultimi 90 giorni',
      newmembers: 'Nuovi',
      all: 'Tutti',
    },
  },
  search: {
    username: 'Nome utente',
    usernamePlaceholder: 'Cerca per nome utente',
    location: 'Posizione',
    nearMe: 'Vicino a me',
    anywhere: 'Ovunque',
    customLocation: 'Posizione personalizzata',
    ranges: 'Intervalli',
    age: 'Età',
    bmi: 'IMC',
    filters: 'Filtri',
    additional: 'Filtri aggiuntivi',
    hasPhotos: 'Ha foto',
    hasPrivatePhotos: 'Ha foto private',
    isOnline: 'Attualmente online',
    isActive: 'Attivo negli ultimi 90 giorni',
    isNew: 'Nuovo membro',
    isFollower: 'Mi segue',
    imFollowing: 'Seguiti',
    imTheirBodyType: 'Interesse per il mio tipo di corpo',
    clearAll: 'Ripristina',
    search: 'Cerca',
    anything: 'Qualsiasi',
    to: 'a',
    andUnder: 'e meno',
    andAbove: 'e più',
    multipleSelected: '{{count}} selezionati',
    selectedCount: '{{count}} selezionati',
    noneSelected: 'Nessuno selezionato',
    selectAtLeastOneFilter: 'Seleziona almeno un filtro per avviare la ricerca',
    restoredFiltersTitle: 'Filtri ripristinati',
    restoredFiltersDescription:
      'I filtri della tua ultima ricerca sono stati ripristinati. Vuoi ricominciare da zero? Clicca il pulsante ripristina qui sotto.',
  },
  discover: {
    seeMore: 'Vedi altro',
    tabBarHintLead: 'I tuoi tab hanno un menu segreto',
    tabBarHintBody: 'Tieni premuto, scorri e vai a qualsiasi lista in un solo gesto.',
    sectionSubtitles: {
      photos: {
        latest: 'Foto pubbliche della community',
        network: 'Foto pubbliche dei membri che segui',
        private: 'Foto private dei membri che ti autorizzano',
        favorites: 'Foto che ti sono piaciute',
      },
      events: {
        upcoming: 'Tutti gli eventi in programma della community',
        nearby: 'Eventi in programma entro {{distance}}',
        network: 'Eventi a cui partecipano i membri che segui',
        past: 'Eventi passati archiviati della community',
      },
    },
  },
  photos: {
    photoOf: 'Foto di {{userName}}',
    posted: 'Pubblicato',
    latest: 'Ultime foto (Tutti)',
    latest_short: 'Ultime',
    network: 'Ultime foto (Seguiti)',
    network_short: 'Seguiti',
    private: 'Ultime foto (Private)',
    private_short: 'Private',
    favorites: 'Foto preferite',
    favorites_short: 'Preferite',
    addPublicPhoto: 'Aggiungi una foto pubblica',
    addPrivatePhoto: 'Aggiungi una foto privata',
    dropToUploadPublic: 'Rilascia per caricare in Pubblico',
    dropToUploadPrivate: 'Rilascia per caricare in Privato',
    captionPlaceholder: 'Aggiungi una didascalia (opzionale)',
    uploadSuccess: 'Foto caricata',
    uploadFailed: 'Caricamento foto non riuscito',
    uploadingImage: 'Caricamento immagine...',
    policyLink: 'Leggi la nostra politica sulle foto',
    artworkNotice:
      'Le immagini generate dall\u2019IA devono essere identificate come tali e pubblicate con moderazione.',
    artworkNoticeFerzu:
      'Le opere d\u2019arte devono essere accreditate. Le immagini generate dall\u2019IA non sono consentite.',
    empty: 'Nessuna foto da mostrare',
    sensitiveReminder: {
      title: 'Le foto sensibili e non recensite sono nascoste',
      body: 'Le tue impostazioni di sicurezza nascondono foto sensibili e non recensite. Puoi modificare questa preferenza in qualsiasi momento nei Filtri o nelle Impostazioni.',
      action: 'Rivedi opzioni di sicurezza',
      dismiss: 'Ignora',
    },
  },
  photo: {
    menu: {
      editCaption: 'Modifica didascalia',
      useAsProfilePhoto: 'Usa come foto profilo',
      moveToPrivate: 'Sposta nella cartella privata',
      requestReview: 'Richiedi una revisione',
      report: 'Segnala foto',
      delete: 'Elimina foto',
    },
    caption: {
      placeholder: 'Aggiungi una didascalia (opzionale)',
      updateSuccess: 'Didascalia aggiornata',
      updateError: 'Impossibile aggiornare la didascalia',
    },
    profile: {
      confirmTitle: 'Usa come foto profilo',
      confirmMessage: 'Sei sicuro di voler usare questa foto come foto profilo?',
      setSuccess: 'Foto profilo aggiornata',
      setError: 'Impossibile aggiornare la foto profilo',
    },
    private: {
      success: 'Foto spostata nella cartella privata',
      error: 'Impossibile spostare la foto nella cartella privata',
    },
    locked: {
      message:
        'Passa a {{premiumPlan}} per visualizzare foto illimitate nelle liste e a schermo intero.',
    },
    review: {
      requestSuccess: 'Revisione richiesta',
      requestError: 'Impossibile richiedere la revisione',
      dialogTitle: 'Valutazione della foto',
      dialogIntro:
        'Se pensi che il nostro sistema di valutazione basato su IA o i revisori umani abbiano commesso un errore nel determinare la valutazione della tua foto, oppure se vuoi spostare una foto dalla tua cartella Privata a Pubblica, puoi richiedere una revisione manuale per farla valutare di nuovo. Tieni presente che ogni foto può essere revisionata una sola volta e il processo può richiedere alcune ore.',
      possibleRatingsTitle: 'Le possibili valutazioni sono:',
    },
    delete: {
      confirmTitle: 'Elimina foto',
      confirmMessage:
        'Sei sicuro di voler eliminare questa foto? Questa azione non può essere annullata.',
      success: 'Foto eliminata con successo',
      error: 'Impossibile eliminare la foto',
    },
  },
  events: {
    upcoming: 'Prossimi eventi',
    upcoming_short: 'Prossimi',
    nearby: 'Eventi vicini',
    nearby_short: 'Vicini',
    network: 'Eventi della rete',
    network_short: 'Rete',
    attending: 'Partecipando',
    attend: 'Partecipa',
    unattend: 'Non partecipare',
    follow: 'Segui',
    following: 'Seguendo',
    attendees: 'partecipanti',
    attendees_one: 'partecipante',
    attendees_other: 'partecipanti',
    attendees_short: 'Partecipanti',
    followers: 'follower',
    followers_one: 'follower',
    followers_other: 'follower',
    followers_short: 'Follower',
    past: 'Eventi passati',
    past_short: 'Passati',
    organizer: 'Organizzatore',
    curator: 'Curatore',
    curatorNotice:
      "Questa persona aiuta a mantenere gli elenchi degli eventi. Segnala eventuali imprecisioni. Se sei l'organizzatore dell'evento, puoi prendere in carico questa pagina contattando {{communityName}}.",
    date_time: 'Data e ora',
    location: 'Luogo',
    website: 'Sito web',
    empty: 'Nessun evento da mostrare',
    noEventsForMember: 'Nessun evento ancora',
    attendeesCount_one: '{{count}} partecipante',
    attendeesCount_other: '{{count}} partecipanti',
    attendSuccess: 'Stai partecipando a questo evento',
    unattendSuccess: 'Non partecipi più a questo evento',
    attendError: 'Impossibile confermare la partecipazione',
    unattendError: 'Impossibile annullare la partecipazione',
    followError: "Impossibile seguire l'evento",
    unfollowError: "Impossibile smettere di seguire l'evento",
    createSuccess: 'Evento creato',
    updateSuccess: 'Evento aggiornato',
    createError: "Impossibile creare l'evento",
    updateError: "Impossibile aggiornare l'evento",
    deleteSuccess: 'Evento eliminato',
    deleteError: "Impossibile eliminare l'evento",
    deleteEvent: 'Elimina evento',
    deleteConfirmTitle: "Eliminare l'evento?",
    deleteConfirmMessage:
      'Sei sicuro di voler eliminare questo evento? Questa azione non può essere annullata.',
    createEvent: 'Nuovo evento',
    editEvent: 'Modifica evento',
    form: {
      code: 'Codice evento',
      codePlaceholder: 'es. mio-evento-2026',
      codeHint: 'Lettere, numeri, trattini e underscore. Non può iniziare con un numero.',
      name: 'Nome evento',
      namePlaceholder: "Inserisci il nome dell'evento",
      nameHint:
        "Evita di includere la data o il mese nel nome dell'evento. Se proprio devi, aggiungili alla fine del nome.",
      startDate: 'Data di inizio',
      endDate: 'Data di fine (opzionale)',
      selectDate: 'Seleziona una data',
      startTime: 'Ora di inizio',
      endTime: 'Ora di fine',
      selectTime: 'Imposta ora',
      timesError: 'Imposta entrambi gli orari o nessuno',
      location: 'Posizione',
      selectLocation: 'Seleziona posizione',
      venue: 'Luogo, sala o hotel',
      venuePlaceholder: 'es. Centro congressi',
      website: 'Sito web',
      websitePlaceholder: 'https://tuosito.com',
      websiteError: "L'URL del sito web deve iniziare con https://",
      details: 'Dettagli evento',
      detailsPlaceholder: "Descrivi l'evento...",
      organizer: "Sono l'organizzatore di questo evento",
      save: 'Salva modifiche',
      create: 'Crea evento',
      required: 'Obbligatorio',
    },
    addToCalendar: 'Aggiungi al calendario',
    share: {
      title: "Dai un'occhiata a questo evento",
      message: "Dai un'occhiata a {{eventName}}",
      shareEvent: 'Condividi evento',
    },
  },
  post: {
    like_one: '{{count}} mi piace',
    like_other: '{{count}} mi piace',
    comment_one: '{{count}} commento',
    comment_other: '{{count}} commenti',
    addComment: 'Commenta',
    announcement: 'Annuncio',
    singlePost: 'Post',
    newPost: 'Nuovo post',
    placeholder: 'A cosa stai pensando?',
    compose: {
      wallPlaceholder: 'Scrivi sul wall di {{userName}}...',
    },
    publish: 'Pubblica',
    createSuccess: 'Il tuo post è stato pubblicato',
    createError: 'Impossibile pubblicare il post',
    editSuccess: 'Il tuo post è stato aggiornato',
    editError: 'Impossibile aggiornare il post',
    readMore: 'Leggi di più',
    featuredPhoto: {
      warningWithReset:
        "Sembra che tu abbia pubblicato un'altra foto molto di recente, il che significa che questa foto non sarà evidenziata nel feed globale, a meno che tu non aspetti {{minutes}} minuti per pubblicarla",
    },
    menu: {
      edit: 'Modifica il post',
      dismissAnnouncement: "Nascondi l'annuncio",
      share: 'Condividi il post',
      stopNotifications: 'Disabilita le notifiche',
      resumeNotifications: 'Riprendi le notifiche',
      report: 'Segnala il post',
      delete: 'Elimina il post',
    },
    mute: {
      title: 'Disattiva le notifiche per quanto tempo?',
      oneHour: '1 ora',
      eightHours: '8 ore',
      oneDay: '24 ore',
      indefinitely: 'Indefinitamente',
      success: 'Notifiche per questo post disattivate con successo',
      error: 'Impossibile disattivare le notifiche per questo post',
    },
    unmute: {
      success: 'Notifiche per questo post riprese con successo',
      error: 'Impossibile riprendere le notifiche per questo post',
    },
    getMutedState: {
      error: 'Impossibile ottenere lo stato delle notifiche',
    },
    dismissAnnouncement: {
      success: 'Annuncio nascosto',
      error: "Impossibile nascondere l'annuncio",
    },
    delete: {
      confirmTitle: 'Elimina post',
      confirmMessage:
        'Sei sicuro di voler eliminare il post? Questa azione non può essere annullata.',
      success: 'Post eliminato con successo',
      error: 'Impossibile eliminare il post',
    },
    share: {
      title: 'Condividi post',
      message: 'Guarda questo post di {{userName}}',
      success: 'Post condiviso con successo',
      copied: 'Link copiato negli appunti',
      error: 'Impossibile condividere il post',
      shareLink: 'Condividi link',
      copy: 'Copia',
      open: 'Apri',
      postUrl: 'URL del post',
    },
  },
  media: {
    gif_button_label: 'Aggiungi un GIF',
    no_results: 'Nessun GIF trovato',
    failed_to_load: 'Impossibile caricare il GIF',
    search_placeholder: 'Cerca su {{provider}}',
    powered_by: 'Fornito da {{provider}}',
  },
  comments: {
    title: 'Commenti',
    titleOnItem: 'Commenti su {{itemType}} di {{userName}}',
    empty: 'Sii il primo a commentare!',
    add_placeholder: 'Aggiungi un commento...',
    added: 'Il tuo commento è stato pubblicato',
    add_error: 'Impossibile pubblicare il commento',
    editSuccess: 'Il tuo commento è stato aggiornato',
    editError: 'Impossibile aggiornare il commento',
    menu: {
      edit: 'Modifica il commento',
      report: 'Segnala il commento',
      delete: 'Elimina il commento',
    },
    delete: {
      confirmTitle: 'Elimina commento',
      confirmMessage:
        'Sei sicuro di voler eliminare il commento? Questa azione non può essere annullata.',
      success: 'Commento eliminato con successo',
      error: 'Impossibile eliminare il commento',
    },
    viewMore_one: 'Vedi {{count}} altro commento',
    viewMore_other: 'Vedi altri {{count}} commenti',
  },
  likes: {
    title: 'Mi piace',
    titleOnItem: 'Mi piace su {{itemType}} di {{userName}}',
  },
  notifications: {
    title: 'Notifiche',
    titleNative: 'Notifiche push',
    empty: 'Nessuna notifica ancora',
    newNotifications: 'Nuove notifiche',
    clearAll: 'Cancella tutte',
    clearAllConfirmTitle: 'Cancellare le notifiche',
    clearAllConfirmMessage:
      'Questo nasconderà tutte le notifiche, incluse le richieste in sospeso di accesso alle tue foto private. Continuare?',
    clearAllSuccess: 'Notifiche cancellate',
    clearAllError: 'Impossibile cancellare le notifiche',
    dismiss: 'Nascondi notifica',
    dismissSuccess: 'Notifica nascosta',
    dismissError: 'Impossibile nascondere la notifica',
    andOthers_one: '(e {{count}} altro)',
    andOthers_other: '(e {{count}} altri)',
    unlockAcceptSuccess: 'Richiesta di sblocco accettata',
    unlockAcceptError: 'Impossibile accettare la richiesta di sblocco',
    unlockRejectSuccess: 'Richiesta di sblocco rifiutata',
    unlockRejectError: 'Impossibile rifiutare la richiesta di sblocco',
    permissionDisabledTitle: 'Le notifiche push sono disattivate',
    permissionDisabledDescription:
      'Attiva le notifiche dalle impostazioni per non perdere le novità.',
    openSettings: 'Apri impostazioni',
  },
  settings: {
    title: 'Impostazioni',
    appearance: 'Aspetto',
    location: {
      title: 'Posizione',
      current: 'Pubblicato come',
      mode: 'Nome luogo',
      fixed: 'Fisso',
      automatic: 'Automatico',
      enable: 'Abilita posizione...',

      enableHelp: 'Abilita posizione',
      enableHelpBlocked: "Il tuo browser sta attualmente bloccando l'accesso alla tua posizione",
      enableHelpSteps:
        "Per abilitarla, segui i passaggi seguenti:\n\n\u2022 Apri il menu delle informazioni del sito vicino alla barra degli indirizzi (icona del lucchetto, impostazioni o informazioni).\n\u2022 Trova i permessi per questo sito e individua l'impostazione della posizione.\n\u2022 Cambia la posizione su Consenti (o Chiedi ogni volta).\n\u2022 Ricarica la pagina.",
      tips: 'Suggerimenti e privacy',
      fixedSet: 'Posizione pubblicata aggiornata',
      fixedError: 'Impossibile impostare la posizione',
      searchPlaceholder: 'Città, CAP o indirizzo',
      searchHint: 'Digita almeno 2 caratteri',
      noResults: "Nessun luogo corrispondente. Controlla l'ortografia o prova una città vicina.",
      searchError: 'Ricerca del luogo non riuscita',
      pickPlace: 'Scegli un luogo',
      autoDescription:
        'Il nome del luogo (città) che appare nel tuo profilo verrà aggiornato mentre viaggi',
    },
    account: {
      title: 'Account',
      username: {
        title: 'Cambia username',
        title_short: 'Nome utente',
        label: 'Nuovo username',
        placeholder: 'Inserisci nuovo username',
        helper:
          'Scegli un nuovo username da 2 a 20 caratteri che inizi con una lettera. Sono consentiti solo lettere, numeri, - e _.',
        invalid: 'Username non valido',
        unavailable: 'Questo username è già in uso',
        current: 'Username:',
        updateAndSignOut: 'Aggiorna e disconnetti',
        successSignOut: 'Username aggiornato. Accedi di nuovo con il tuo nuovo username.',
        error: "Impossibile aggiornare l'username",
      },
      email: {
        title: 'Cambia email',
        title_short: 'Email',
        label: 'Nuova email',
        placeholder: 'Inserisci nuova email',
        changeExplanation:
          "Invieremo un link di conferma al tuo nuovo indirizzo. L'email verrà aggiornata dopo la conferma.",
        invalid: 'Inserisci un indirizzo email valido',
        unavailable: 'Questa email è già in uso',
        current: 'Email:',
        success: 'Cambio email richiesto. Controlla la posta per confermare.',
        error: "Impossibile aggiornare l'email",
      },
      password: {
        title: 'Cambia password',
        change: 'Cambia password',
        old: 'Password attuale',
        new: 'Nuova password (min 6 caratteri)',
        repeat: 'Ripeti la nuova password',
        mismatch: 'Le password non corrispondono',
        oldRequired: 'Inserisci la password attuale',
        success: 'Password aggiornata',
        error: 'Impossibile aggiornare la password',
      },
      delete: {
        title: 'Elimina account',
        confirmLabel: 'Conferma con la password attuale',
        confirmMessage: 'Questa azione è permanente. Digita la tua password per confermare.',
        placeholder: 'Inserisci la password attuale',
        submit: 'Elimina il mio account',
        required: 'Inserisci la password attuale',
        success: 'Il tuo account è stato eliminato',
        error: "Impossibile eliminare l'account",
      },
    },
    privacy: {
      title: 'Privacy e Sicurezza',
      blockedMembers: 'Membri bloccati',
      photoUnlockAuthorized: 'Autorizzazioni foto private',
      emptyHelp: {
        blocked:
          'Qui verranno mostrati i membri che blocchi. Puoi rimuovere i blocchi in qualsiasi momento.',
        photoUnlockAuthorized:
          "Qui verranno mostrati i membri a cui hai concesso l'accesso alle tue foto private. Puoi revocare l'accesso in qualsiasi momento.",
      },
      removeUnlock: {
        title: 'Rimuovi accesso',
        action: 'Rimuovi accesso',
        confirmMessage: "Rimuovere l'accesso alle tue foto private per {{userName}}?",
        success: 'Accesso rimosso',
        error: "Impossibile rimuovere l'accesso",
      },
    },
    language: 'Lingua',
    system: 'Come il sistema',
    community: 'Comunità',
    pattern: "Motivo dell'intestazione",
    patterns: {
      none: 'Nessuno',
      bones: 'Ossa e zampe',
      circles: 'Cerchi',
      food: 'Cibo',

      japanese: 'Giapponese',
      plaid: 'Scozzese',
      polygonal: 'Poligonale',
      sprinkles: 'Coriandoli',
      stars: 'Stelle',
      triangles: 'Triangoli',
    },
    appIcon: {
      title: "Icona dell'app",
      description: "Scegli l'icona che appare sulla tua schermata iniziale.",
      changed: "Icona dell'app aggiornata",
    },
    theme: {
      title: 'Tema',
      auto: 'Come il sistema',
      light: 'Modalità chiara',
      dark: 'Modalità scura',
    },
    units: {
      title: 'Unità',
      distance: 'Distanza',
      distanceKm: 'Chilometri (km)',
      distanceMi: 'Miglia (mi)',
      height: 'Altezza',
      heightM: 'Metri (m)',
      heightFt: 'Piedi (ft)',
      weightUnit: 'Peso',
    },
    diagnostics: {
      title: 'Strumenti di diagnostica',
      signalr: 'Diagnostica SignalR',
      clearCache: 'Svuota cache',
      cacheCleared: 'Cache svuotata con successo',
    },
    preferences: {
      title: 'Preferenze',
      birthdayList: 'Lista compleanni',
      birthdayListDescription: 'Mostrami nella lista dei compleanni',
      anonymousViewing: 'Visualizzazione anonima',
      anonymousViewingDescription: 'Naviga i profili senza apparire nella lista visitatori',
      inboundMessagePhotos: 'Foto in arrivo',
      inboundMessagePhotosDescription:
        'Consenti foto nei DM da chiunque (altrimenti solo da persone che segui)',
      emailNotifications: 'Notifiche email',
      emailNotificationsDescription: 'Ricevi email per nuovi messaggi',
      photosInNewsfeed: 'Foto nel newsfeed',
      photosInNewsfeedDescription: 'Mostra post con foto nel newsfeed globale',
      mediaInComments: 'Mostra GIF nei commenti',
      mediaInCommentsDescription:
        'Mostra GIF e altri media nei commenti di post e foto.',
      safeModeOff: 'Media sensibili e non recensiti',
      safeModeOffDescription:
        'Mostra contenuti multimediali che potrebbero contenere materiale sensibile (NSFW)',
    },
    safety: {
      title: 'Opzioni di sicurezza',
    },
    notifications: {
      title: 'Notifiche',
      titleWithSounds: 'Notifiche e suoni',
      description: 'Scegli quali attività attivano le notifiche push',
      futureNotifications:
        'Le seguenti notifiche push sono pianificate per implementazione futura e non sono attualmente attive.',
      newMessage: 'Nuovi messaggi',
      newMessageDescription: 'Quando qualcuno ti invia un messaggio',
      newFollower: 'Nuovi follower',
      newFollowerDescription: 'Quando qualcuno ti segue',
      newPhotoComment: 'Commenti alle foto',
      newPhotoCommentDescription: 'Quando qualcuno commenta le tue foto',
      newPostComment: 'Commenti ai post',
      newPostCommentDescription: 'Quando qualcuno commenta i tuoi post',
      newWallPost: 'Post sulla bacheca',
      newWallPostDescription: 'Quando qualcuno pubblica sulla tua bacheca',
      web: {
        mobileTitle: 'Le notifiche push non sono disponibili sul web',
        mobileSubtitle:
          "Installa l'app iOS o Android per ricevere notifiche push quando qualcuno ti scrive o interagisce con i tuoi contenuti.",
        soundsDescription:
          'Scegli un suono da riprodurre quando arriva qualcosa di nuovo. I suoni vengono riprodotti dal browser, quindi tieni aperta la scheda {{communityName}}.',
        messageSoundLabel: 'Suono per nuovo messaggio',
        notificationSoundLabel: 'Suono per nuova notifica',
        preview: 'Ascolta il suono',
        appStoreButton: 'Scarica su App Store',
        googlePlayButton: 'Disponibile su Google Play',
      },
      sounds: {
        off: 'Disattivato',
        trill: 'Trillo',
        stepUp: 'Salita',
        bubblePop: 'Pop di bolla',
        marimba: 'Marimba',
        metro: 'Metro',
        retro: 'Retro',
        sparkle: 'Scintillio',
        strings: 'Archi',
      },
    },
    dangerZone: 'Zona pericolosa',
    about: {
      title: 'Informazioni su questa app',
      version: 'Versione',
      build: 'build',
      madeWithCities: 'Creato con ❤️ a Montreal, New York e San Francisco',
      whatsNew: 'Novità di questa versione',
    },
  },
  whatsNew: {
    title: 'Novità',
    currentReleaseTitle: 'In questa versione',
    catchUpReleaseTitle: "Dall'ultimo aggiornamento",
    recentUpdatesTitle: 'Aggiornamenti recenti',
    lineageLabel: 'Versione {{lineage}}',
    empty: 'Nessuna novità da mostrare.',
    neverShowAgain: 'Non mostrare più',
    showOnNewVersions: 'Mostra questa schermata nelle nuove versioni',
  },
  upgrade: {
    prompt: 'Ottieni foto a dimensione intera nel tuo feed senza limiti giornalieri',
    upgrade_button: 'Ottieni Premium',
  },
  premium: {
    upgradeCard: {
      photos: '...e molte altre! Passa a {{premiumPlan}} per vedere tutte le foto.',
      members: '...e molti altri! Passa a {{premiumPlan}} per vedere tutti i membri.',
      conversation:
        'Passa a {{premiumPlan}} per accedere a tutto lo storico delle tue conversazioni.',
    },
  },
  paywall: {
    ViewFullsizePhoto:
      'Limite attuale raggiunto per visualizzare foto a dimensione intera. Passa a {{premiumPlanName}} per accesso illimitato.',
    OutgoingCommunication:
      'Limite attuale raggiunto per inviare messaggi e post. Passa a {{premiumPlanName}} per comunicazioni illimitate.',
    NewsfeedSearch:
      'Limite attuale raggiunto per le ricerche nel feed. Passa a {{premiumPlanName}} per ricerche illimitate.',
    ValidateGiftCertificate: 'Limite attuale raggiunto per le convalide di certificati regalo.',
    Blocks:
      'Hai raggiunto il numero massimo di membri bloccati. Passa a {{premiumPlanName}} per più blocchi.',
    BlockingAMember:
      'Hai recentemente bloccato o sbloccato questo membro. Attendi 3 giorni prima di bloccarlo o sbloccarlo nuovamente.',
    PostsPerHour:
      'Hai raggiunto il tuo limite di post orari. Attendi prima di pubblicare nuovamente.',
    ChangeOfEmail: 'Limite attuale raggiunto per le richieste di cambio email. Riprova domani.',
    PhotoStream:
      'Limite attuale raggiunto per visualizzare stream di foto. Passa a {{premiumPlanName}} per accesso illimitato.',
    FeaturedPhotos:
      "Puoi mettere in evidenza solo una foto nel feed globale all'ora. Attendi prima di pubblicarne un'altra.",
    PhotoUnlockRequests:
      'Limite attuale raggiunto per richieste di sblocco foto. Passa a {{premiumPlanName}} per richieste illimitate.',
    AnonymousViewing:
      'La visualizzazione anonima richiede un abbonamento {{premiumPlanName}}. Passa a {{premiumPlanName}} per navigare i profili senza apparire nelle liste visitatori.',
    PostsPerDay: 'Hai raggiunto il tuo limite di post giornalieri. Riprova domani.',
    UploadedPhotos:
      'Hai raggiunto il tuo limite di foto. Passa a {{premiumPlanName}} per caricare più foto.',
    UploadedPhotosPerDay:
      'Hai raggiunto il tuo limite giornaliero di caricamento foto. Passa a {{premiumPlanName}} per caricare più foto oggi.',
    MemberSearch:
      'Hai raggiunto il limite giornaliero di ricerche. Passa a {{premiumPlanName}} per ricerche illimitate.',
    MyTypeFilterChange:
      'Hai raggiunto il limite giornaliero per modificare il tuo filtro di tipo. Passa a {{premiumPlanName}} per modificarlo quando vuoi.',
    default:
      'Questa funzionalità richiede un account {{premiumPlanName}}. Passa a {{premiumPlanName}} per continuare.',
    resetIn: {
      minutes_one: 'Riprova tra {{count}} minuto',
      minutes_other: 'Riprova tra {{count}} minuti',
      hours_one: 'Riprova tra {{count}} ora',
      hours_other: 'Riprova tra {{count}} ore',
    },
  },
  notFound: {
    title: 'Ci dispiace, non riusciamo a trovare ciò che stai cercando.',
    goHome: 'Torna alla schermata iniziale',
  },
  communitiesHeader: {
    title: 'Comunità',
  },
  profile: {
    aboutMe: 'Su di me',
    stats: 'Statistiche',
    bio: 'Biografia',
    height: 'Altezza',
    weight: 'Peso',
    gender: 'Genere',
    origin: 'Origine',
    relationship: 'Relazione',
    languages: 'Lingue',
    interestedIn: 'Interessato a',
    preferences: 'Preferenze',
    lookingFor: 'Cerca',
    bodyTypesLiked: 'Tipi di corpo',
    bodyPartsLiked: 'Caratteristiche corporali',
    sexualInterests: 'Interessi sessuali',
    mutualKinks: 'Feticci comuni',
    // Shared field labels (used by search, profile view, and edit profile)
    identifyAs: 'Si identifica come',
    relationshipStatus: 'Stato sentimentale',
    bodyTypes: 'Tipi di corpo',
    bodyHair: 'Peli del corpo',
    facialHair: 'Peli del viso',
    communityKinks: 'Feticci della comunità',
    otherKinks: 'Altri feticci',
    // Section titles
    sections: {
      identity: 'Identità e origini',
      interestsAndKinks: 'Interessi e kink',
      bodyFeatures: 'Tipi di corpo e caratteristiche',
    },
    // Units
    units: {
      weight: {
        pounds: 'Libbre (lb)',
        kilograms: 'Chilogrammi (kg)',
        stones: 'Stones (st)',
        short: {
          lb: 'lb',
          kg: 'kg',
          st: 'st',
        },
        suffix: {
          lbs: 'lbs',
          kg: 'kg',
          st: 'st',
        },
      },
      height: {
        feet: 'Piedi (ft)',
        meters: 'Metri (m)',
        short: {
          ft: 'ft',
          m: 'm',
        },
        suffix: {
          m: 'm',
        },
      },
    },
    lastSeen: "Visto l'ultima volta",
    lastVisitedYou: 'Ha visto il profilo',
    notYet: 'Non ancora',
    activity: 'Attività',
    joinDateWithCommunity: 'Su {{communityName}} dal',
    seeAllPhotos: 'Vedi tutto',
    followers: 'follower',
    followers_one: 'follower',
    followers_other: 'follower',
    following: 'seguendo',
    following_one: 'seguendo',
    following_other: 'seguendo',
    follows_you: 'Ti segue',
    followersCount_one: '{{count}} follower',
    followersCount_other: '{{count}} follower',
    followingCount: '{{count}} seguendo',
    followersOfUser: 'Follower di {{userName}}',
    followingOfUser: '{{userName}} sta seguendo',
    tabs: {
      about: 'Informazioni',
      posts: 'Post',
      photos: 'Foto',
      events: 'Eventi',
      weight: 'Peso',
      wall: 'Bacheca',
    },
    photos: {
      public: 'Pubbliche',
      private: 'Private',
      privateLocked: 'Le foto private sono bloccate',
      requestAccess: 'Richiedi accesso',
      extendedPreviewNotice: 'Vedi più foto perché questo membro ha {{premiumPlan}}.',
      requestPending: 'La tua richiesta di accesso alle foto private è in attesa di approvazione',
      requestSubmitted: 'Richiesta di accesso inviata',
      requestFailed: 'Impossibile inviare la richiesta di accesso',
    },
    wall: {
      empty: 'Nessun post da mostrare',
    },
    share: {
      title: 'Condividi profilo',
      message: "Dai un'occhiata al profilo di {{userName}}",
      shareProfile: 'Condividi profilo',
    },
  },
  member: {
    notFound: 'Membro non trovato',
    menu: {
      report: 'Segnala membro',
      block: 'Blocca membro',
      unblock: 'Sblocca membro',
      privatePhotosSection: 'Foto private',
      revokePrivatePhotos: {
        action: 'Revoca accesso',
        confirmTitle: 'Revoca accesso',
        confirmMessage:
          '{{userName}} non potrà più vedere le tue foto private. Potrà inviarti una nuova richiesta più tardi.',
        success: 'Accesso revocato',
        error: "Impossibile revocare l'accesso",
      },
      forfeitPrivatePhotos: {
        action: 'Annulla iscrizione',
        confirmTitle: 'Annulla iscrizione',
        confirmMessage:
          "Non potrai più vedere le foto private di {{userName}}. Potrai richiedere di nuovo l'accesso più tardi.",
        success: 'Iscrizione annullata',
        error: "Impossibile annullare l'iscrizione",
      },
    },
    block: {
      confirmMessage:
        'Sei sicuro di voler bloccare {{userName}}? Questa azione non può essere annullata per le prossime 72 ore per prevenire molestie.',
      success: 'Membro bloccato con successo',
      error: 'Impossibile bloccare il membro',
    },
    unblock: {
      confirmMessage:
        'Sei sicuro di voler sbloccare {{userName}}? Questa azione non può essere annullata per le prossime 72 ore per prevenire molestie.',
      success: 'Membro sbloccato con successo',
      error: 'Impossibile sbloccare il membro',
    },
    unfollow: {
      confirmTitle: 'Non seguire più',
      confirmMessage: 'Sei sicuro di non voler più seguire {{userName}}?',
      success: 'Non segui più {{userName}}',
      error: 'Impossibile smettere di seguire il membro',
    },
    follow: {
      success: 'Ora stai seguendo {{userName}}',
      error: 'Impossibile seguire il membro',
    },
    locked: {
      message: 'Passa a {{premiumPlan}} per esplorare un numero illimitato di profili dei membri.',
    },
  },
  userMenu: {
    viewProfile: 'Vedi il mio profilo',
    editProfile: 'Modifica il mio profilo',
    settings: 'Impostazioni',
    plans: 'Piani e abbonamento',
    help: 'Aiuto e supporto',
    feedback: 'Feedback',
    rules: 'Regole della comunità',
    browseCommunities: 'Esplora comunità',
    signOut: 'Disconnetti',
  },
  editProfile: {
    title: 'Modifica profilo',
    saveSuccess: 'Profilo aggiornato con successo',
    saveError: 'Impossibile aggiornare il profilo',
    loadError: 'Impossibile caricare il profilo',
    saving: 'Salvataggio...',
    sections: {
      basicInfo: 'Informazioni di base',
    },
    firstName: 'Nome',
    firstNamePlaceholder: 'Inserisci il tuo nome',
    birthDate: 'Data di nascita',
    selectYear: 'Seleziona anno',
    selectMonth: 'Seleziona mese',
    selectDay: 'Seleziona giorno',
    selectHeight: 'Seleziona altezza',
    weightGoal: 'Obiettivo di peso',
    weightRangeError: "Il peso deve essere compreso nell'intervallo consentito",
    descriptionPlaceholder: 'Parlaci di te...',
    textPlaceholder: 'Inserisci testo...',
    notSet: 'Non impostato',
    identifyAs: 'Mi identifico come',
    myBodyType: 'Il mio tipo di corpo',
    bodyTypesLiked: 'Tipi di corpo che mi piacciono',
    bodyPartsLiked: 'Caratteristiche fisiche che mi piacciono',
    myBodyHair: 'I miei peli del corpo',
    myFacialHair: 'I miei peli del viso',
    hints: {
      firstName: 'Opzionale. Appare sul tuo profilo dopo il tuo nome utente.',
      birthDate:
        'Non visibile agli altri utenti. Usato per verificare che sei maggiorenne e mostrare la tua età.',
      bio: 'Racconta agli altri di te, cosa ti piace e cosa stai cercando.',
    },
  },
  account: {
    plans: {
      title: 'Piani e abbonamento',
      includedWith: 'Cosa è incluso con {{planName}}',
      choosePlan: 'Scegli il tuo piano',
      terms: 'Termini',
      bestValue: 'MIGLIOR VALORE',
      monthlyPlan: 'Piano Mensile {{planName}}',
      yearlyPlan: 'Piano Annuale {{planName}}',
      regularPrice: 'Prezzo normale',
      perMonth: 'al mese',
      perYear: "all'anno",
      onlyPerMonth: 'Solo {{price}}/mese (risparmia {{percent}}%)',
      pricesIn: 'Prezzi in {{currency}}.',
      billingTerms_ios:
        "Il pagamento verrà addebitato sul tuo account Apple alla conferma dell'acquisto. I piani sono validi per il periodo selezionato e si rinnoveranno automaticamente al prezzo indicato a meno che non vengano cancellati almeno 24 ore prima della fine del periodo corrente. Puoi cancellare il tuo abbonamento in qualsiasi momento dalle impostazioni del dispositivo o utilizzando Gestisci abbonamento sopra.",
      billingTerms_android:
        "Il pagamento verrà addebitato sul tuo account Google alla conferma dell'acquisto. I piani sono validi per il periodo selezionato e si rinnoveranno automaticamente al prezzo indicato a meno che non vengano cancellati almeno 24 ore prima della fine del periodo corrente. Puoi cancellare il tuo abbonamento in qualsiasi momento dalle impostazioni del dispositivo o utilizzando Gestisci abbonamento sopra.",
      billingTerms_web:
        "I termini dell'abbonamento e i dettagli di fatturazione saranno forniti al momento del checkout. Il tuo abbonamento si rinnoverà automaticamente a meno che non venga cancellato prima della data di rinnovo.",
      privacyPolicy: 'Informativa sulla privacy',
      termsOfUse: 'Termini di utilizzo',
      manageSubscription: 'Gestisci abbonamenti',
      currentPlan: 'Piano attuale',
      loading: 'Caricamento piani...',
      confirming: 'Conferma del tuo abbonamento...',
      connecting: 'Connessione al negozio...',
      connectionError: 'Errore di Connessione',
      openPlayStore: 'Apri Play Store',
      signInToPlayStore: 'Accedi a Google Play Store per continuare',
      openAppStore: 'Apri App Store',
      checkAppStoreConnection: "Verifica la tua connessione all'App Store e riprova",
      premiumFeatures: {
        unlimitedPhotos: 'Visualizzazione illimitata di foto',
        featureMorePhotosToRegularMembers: 'Mostra più foto ai membri senza abbonamento',
        unlimitedMessaging: 'Messaggistica illimitata',
        moreBlocks: 'Più blocchi',
        morePhotoUploads: 'Più caricamenti di foto',
      },
      learnMoreAboutPlans: 'Scopri tutto sui nostri piani',
      yourAccountIsOn: 'Il tuo account è sul piano {{planName}}',
      currentCreditsUntil: 'Crediti attuali validi fino al:',
      daysLeft_one: '{{count}} giorno rimanente',
      daysLeft_other: '{{count}} giorni rimanenti',
      hoursLeft_one: '{{count}} ora rimanente',
      hoursLeft_other: '{{count}} ore rimanenti',
      subscriptionRenewalNote:
        'Il tuo abbonamento si rinnova automaticamente in base al tuo ciclo di fatturazione. Ogni rinnovo aggiunge crediti al tuo account. I crediti da promozioni o buoni regalo possono estendersi oltre il periodo di abbonamento corrente. Grazie per essere un membro {{planName}}!',
      billingNotAvailable: 'Gli abbonamenti non sono attualmente disponibili',
      grandfatheredPricing: 'Congratulazioni! Hai mantenuto i nostri precedenti prezzi più bassi.',
      oneMonth: 'Mensile',
      threeMonths: 'Trimestrale',
      oneYear: 'Annuale',
      oneYearCombo: 'Annuale Duo',
      comboSubtitle: 'Include Grommr XL e 1 anno di Chasable+ (certificato regalo)',
      every3Months: 'ogni 3 mesi',
      save: 'risparmia {{percent}}%',
      renewsEveryDays: 'Si rinnova automaticamente ogni {{days}} giorni',
      subscribe: 'Iscriviti',
      subscribed: 'Iscritto',
      manageCCBill: 'Annulla/gestisci un abbonamento CCBill',
      subscriptionIdLabel: 'Il tuo ID abbonamento CCBill più recente',
      subscriptionIdCopied: 'ID abbonamento copiato negli appunti',
      ccbillPayments: 'Pagamenti CCBill (Abbonamenti)',
      ccbillDescription:
        'Utilizziamo CCBill per gestire la nostra fatturazione e ci sono vari modi per acquistare il tuo pass con carta di credito: Accettiamo Visa, Mastercard, JCP e Discover. L\'estratto conto della tua carta di credito mostrerà "CCBill.Com *Grokio" (Grokio Communities LLC è la società operativa dietro {{communityName}}). Hai la possibilità di effettuare la transazione in una delle cinque valute: USD; EUR; GBP; CAD; AUD; e JPY. Non appena riceveremo la conferma che il pagamento è stato effettuato, il nuovo tempo verrà aggiunto al tuo account (nella maggior parte dei casi dovrebbe essere immediato). Tutti gli abbonamenti tramite CCBill si rinnovano automaticamente. Se desideri annullare il tuo abbonamento, puoi utilizzare il link fornito e annullarlo almeno 48 ore prima del rinnovo.',
      billingFaq: 'Informazioni sulla fatturazione e FAQ',
      billingFaqDescription:
        'Consulta il nostro documento Informazioni sulla fatturazione di {{planName}} per dettagli su pagamenti, rinnovi e cancellazioni.',
      billingFaqGuide: 'Guida a {{planName}}',
      getBillingSupport: 'Ottieni supporto per la fatturazione',
      restorePurchases: 'Ripristina acquisti',
      error: {
        loadProducts: 'Caricamento piani di abbonamento non riuscito',
        noProductsFound: 'Nessun prodotto di abbonamento trovato',
        purchase: 'Acquisto non riuscito',
        purchasePayment:
          'Il tuo acquisto non è andato a buon fine. Controlla il metodo di pagamento e riprova.',
        purchaseNetwork:
          'Impossibile connettersi allo store. Controlla la tua connessione internet e riprova.',
        purchaseUnavailable:
          'Gli acquisti in-app non sono disponibili su questo dispositivo o account.',
        purchaseAlreadyOwned: 'Hai già un abbonamento attivo per questo piano.',
        purchaseDeferred:
          "Il tuo pagamento è in attesa di approvazione. L'abbonamento verrà attivato una volta approvato.",
        purchaseItemUnavailable: 'Questo piano di abbonamento non è attualmente disponibile.',
        validation: 'Convalida acquisto non riuscita',
        restore: "Ripristino non riuscito — riprova o contatta l'assistenza",
        restoreUnavailable:
          'Impossibile raggiungere lo store. Controlla la connessione e riprova.',
      },
      success: {
        subscribedWithPlan: 'Grazie per esserti abbonato! Il tuo piano {{planName}} è ora attivo.',
        subscribedWithBogo:
          'Grazie per esserti abbonato! Il tuo {{planName}} è ora attivo. Bonus: Hai guadagnato un {{period}} extra con la nostra promozione!',
        restored: 'Acquisti ripristinati con successo',
        nothingToRestore: 'Nessun acquisto da ripristinare',
      },
    },
    transactions: {
      title: 'Storico transazioni',
      empty: 'Nessuna transazione ancora',
      days_one: 'giorno',
      days_other: 'giorni',
      header: {
        date: 'Data',
        description: 'Descrizione',
      },
    },
    certificates: {
      title: 'Certificati Regalo',
      history: 'I tuoi certificati regalo',
      empty: 'Nessun certificato regalo ancora',
      purchase: 'Acquisto Certificato Regalo',
      redeemed: 'Certificato Regalo Riscattato',
      redeemedOn: 'Riscattato il {{date}}',
      codeCopied: 'Codice del certificato copiato negli appunti',
      redeem: {
        title: 'Riscatta un certificato regalo',
        helper: 'Inserisci il codice che hai ricevuto per aggiungere tempo premium al tuo account.',
        placeholder: 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX',
        button: 'Riscatta',
        success_one: 'Certificato regalo riscattato! È stato aggiunto {{count}} giorno al tuo account.',
        success_other: 'Certificato regalo riscattato! Sono stati aggiunti {{count}} giorni al tuo account.',
        invalidFormat: 'Questo non sembra un codice di certificato regalo. I codici hanno 25 lettere e numeri.',
        notFound: 'Non abbiamo trovato questo codice. Assicurati di riscattarlo nella community per cui è stato emesso.',
        alreadyRedeemed: 'Questo certificato regalo è già stato riscattato.',
        tooManyAttempts: 'Troppi tentativi. Riprova domani.',
        error: 'Non siamo riusciti a riscattare questo certificato regalo. Riprova più tardi.',
      },
      header: {
        date: 'Data',
        details: 'Dettagli',
      },
    },
  },
  webDrop: {
    dropToUpload: "Rilascia un'immagine per caricarla",
    dragHint: "Trascina qui un'immagine JPG/PNG",
  },
  weightHistory: {
    stats: 'Statistiche',
    currentWeight: 'Attuale',
    trend: 'Tendenza',
    bmi: 'IMC',
    goal: 'Obiettivo',
    perMonth: '/mese',
    history: 'Cronologia',
    date: 'Data',
    weight: 'Peso',
    notes: 'Note',
    noData: 'Nessun registro di peso ancora',
    noChartData: 'Dati insufficienti per il grafico',
    addRecord: 'Aggiungi',
    editRecord: 'Modifica peso',
    selectDate: 'Seleziona data',
    notesPlaceholder: 'Note facoltative...',
    added: 'Peso aggiunto',
    updated: 'Peso aggiornato',
    deleted: 'Registro di peso eliminato',
    saveFailed: 'Salvataggio non riuscito',
    deleteFailed: 'Eliminazione del registro non riuscita',
    deleteTitle: 'Elimina',
    deleteConfirm: 'Eliminare questo registro di peso?',
  },
  footer: {
    support: 'Supporto',
    terms: 'Termini di utilizzo',
    privacy: 'Informativa sulla privacy',
  },
  report: {
    reasonTitle: 'Perché stai segnalando questo?',
    rulesLink: 'Leggi le Regole della community',
    reasons: {
      scam: 'Truffatore',
      spam: 'Spam',
      falsePortrayal: 'Falsa identità',
      harassment: 'Molestie',
      intolerance: 'Intolleranza',
      trolling: 'Trolling',
      disparagement: 'Denigrazione',
      donationRequest: 'Richiesta di donazioni',
      promotionalPosting: 'Violazione sui post promozionali',
      photoPolicy: 'Violazione della policy sulle foto',
      uncreditedArtwork: 'Opera non accreditata',
      underage: 'Minorenne',
      illegalActivity: 'Altre attività illegali',
      other: 'Altro',
    },
  },
};
